import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export class EnNavHeader extends Component {
    static displayName = EnNavHeader.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            isAuthenticated: !!sessionStorage.getItem('username') // Check if username exists in session storage
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    render() {
        const { isAuthenticated } = this.state;

        return (
            <>
                <header className="header-main">
                    <nav id="navbar_top" className="navbar navbar-expand-md bg-white">
                        <div className="container">
                            <a href="https://www.starbucks.co.th/" className="navbar-brand col-2 col-md-1 pe-0 me-0" id="logo"><img src={require("./media/starbucks_corporation_logo.png")} alt="Starbucks" className="img-fluid" rel="noopener noreferrer" /></a>
                            <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon" />
                            </button>
                            <div className="navbar-collapse collapse rounded-bottom" id="navbarCollapse" style={{}}>
                                <ul className="navbar-nav me-auto mb-2 mb-md-0">
                                    <li className="nav-item">
                                        <a className="nav-link" href="https://www.starbucks.co.th/en/coffee" rel="noopener noreferrer">
                                            COFFEE &amp; TEA AT HOME
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="https://www.starbucks.co.th/en/menu" rel="noopener noreferrer">
                                            MENU
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="https://www.starbucks.co.th/en/merchandise" rel="noopener noreferrer">
                                            MERCHANDISE
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/">STARBUCKS REWARDS</Link>
                                    </li>
                                </ul>
                                <div className="d-flex px-3 px-md-0">
                                    <ul className="header-nav header-nav-main nav nav-right nav-line-bottom nav-spacing-large nav-uppercase mt-4">
                                        <li className="html_topbar_left">
                                            <a href="https://www.starbucks.co.th/find-a-store/" className="link-find-store en-link" rel="noopener noreferrer">
                                                <i className="fa-solid fa-location-dot pe-1" /> <span>Find a Store</span></a>
                                            <Link to="/authsignin" className="btn btn-outline-dark rounded-pill text-decoration-none"><span>Sign in</span></Link>
                                            <Link to="/authjoinnow" className="btn btn-dark rounded-pill text-decoration-none me-2"><span>Join now</span></Link> |
                                            <Link to="/logoutth" className="lang-link"><img src={require("./media/th.png")} className="ms-1 me-1" alt="ไทย" width={18} height={12} /> ไทย</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </nav>
                </header>

            </>
        );
    }
}
